import axios from "@/axios";

export default {
  namespaced: true,
  state: {
    loading: false,
    bookings: [],
    loadingPlanning: false,
    planning: [],
  },
  getters: {
    loading(state) {
      return state.loading;
    },
    bookings(state) {
      return state.bookings;
    },
    loadingPlanning(state) {
      return state.loadingPlanning;
    },
    checkinsPlanning(state) {
      return state.planning;
    },
  },
  mutations: {
    RESET(state) {
      state.loading = false;
      state.bookings = [];
      state.loadingPlanning = false;
      state.planning = [];
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_BOOKINGS(state, payload) {
      state.bookings = payload;
    },
    SET_LOADING_PLANNING(state, payload) {
      state.loadingPlanning = payload;
    },
    SET_PLANNING(state, payload) {
      state.planning = payload;
    },
    UPDATE_BOOKING_CLEANING_STATUS(state, { uuid, cleaningCompleted }) {
      const booking = state.planning.find((b) => b.stats?.uuid === uuid);
      if (!booking) return;
      if (!booking.stats) booking.stats = {};
      booking.stats.cleaningCompleted = cleaningCompleted;
    },
  },
  actions: {
    reset({ commit }) {
      commit("RESET");
    },
    fetchPlanning({ commit }) {
      commit("SET_LOADING_PLANNING", true);

      return new Promise((resolve, reject) => {
        axios
          .get("/provider_bookings")
          .then((response) => {
            commit("SET_PLANNING", response.data["hydra:member"]);
            resolve(response);
          })
          .catch((error) => {
            reject(error.response);
          })
          .finally(() => commit("SET_LOADING_PLANNING", false));
      });
    },
    updateBookingStats({ commit }, { uuid, cleaningCompleted }) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`/booking_stats/${uuid}`, { cleaningCompleted }, {
            headers: { "Content-Type": "application/merge-patch+json" },
          })
          .then((response) => {
            commit("UPDATE_BOOKING_CLEANING_STATUS", { uuid, cleaningCompleted });
            resolve(response);
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    },
    fetchBookings({ state, commit }, payload = {}) {
      commit("SET_LOADING", true);

      let url = "/bookings?";
      if ("pagination" in payload) url += `&pagination=${payload.pagination}`;
      if ("itemsPerPage" in payload)
        url += `&itemsPerPage=${payload.itemsPerPage || state.itemsPerPage}`;
      if ("page" in payload) url += `&page=${payload.page}`;

      return new Promise((resolve, reject) => {
        axios
          .get(url)
          .then((response) => {
            if (response.status === 200) {
              commit("SET_BOOKINGS", response.data["hydra:member"]);
              resolve(response);
            } else {
              reject(
                new Error({
                  status: response.status,
                  message: "Error while fetching all the bookings",
                })
              );
            }
          })
          .catch((error) => {
            reject(error.response);
            // TODO: log error in Sentry
          })
          .finally(() => commit("SET_LOADING", false));
      });
    },
  },
};
